var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignCenterHorizontalSimple = function SvgIconAlignCenterHorizontalSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.5a1 1 0 0 1 1 1v2.75h6.5c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 0 1-1.75 1.75H13v2.75a1 1 0 1 1-2 0v-2.75H4.5A1.75 1.75 0 0 1 2.75 15V9c0-.966.784-1.75 1.75-1.75H11V4.5a1 1 0 0 1 1-1m7.25 11.25v-5.5H4.75v5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconAlignCenterHorizontalSimple;